<template>
  <div id="PaymentConfirmation">
    <div class="container">
      <div v-if="isPaymentConfirmationLoading">
        <b-spinner class="brand-primary"></b-spinner>
      </div>
      <div v-else class="gp-select-container mb-5 pb-5" ref="gpSelectTop">
        <BookingConfirmed v-if="isPaymentSuccessful" />
        <div
          class="d-flex flex-column align-items-center justify-content-center"
          v-else
        >
          <h3 class="dmh-start-title">Failed to book</h3>
          <div class="text">
            Something went wrong and your session failed to book successfully.
            Please contact support.
          </div>
          <b-button
            size="lg"
            id="return-to-home-button"
            class="btn-home py-4 px-5 w-100"
            squared
            @click="returnToPortal"
            >Return to portal</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "../config/constants";
import BookingConfirmed from "../components/DMH/BookingConfirmed.vue";
import { returnHome } from "@/utils/embed/partnerEmbed";

export default {
  name: "PaymentConfirmation",
  props: ["reset", "previous", "questionHistory"],
  components: {
    BookingConfirmed
  },
  data() {
    return {
      isPaymentConfirmationLoading: true,
      isPaymentSuccessful: null
    };
  },
  mounted() {
    setTimeout(() => {
      this.getData();
    }, 3000);
  },
  methods: {
    returnToPortal() {
      // Booking failed, so this isn't sl:booking-complete.
      returnHome(this.$router, { type: "sl:close", v: 1, reason: "booking_failed" });
    },
    async getData() {
      try {
        const payload = {
          user_id: this.$store.getters.user_id,
          session_id: this.$route.query.session_id
        };
        const res = await axios.post(
          config.api_env + "/application/api/u/dmh/get-payment-confirmation",
          payload,
          config.options
        );
        if (res.data.success) {
          this.isPaymentSuccessful = res.data.booking_success;
        } else {
          this.isPaymentSuccessful = false;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isPaymentConfirmationLoading = false;
      }
    }
  }
};
</script>
<style lang="less">
#PaymentConfirmation {
  background-color: #fff;
  width: 100%;

  .container {
    width: 100%;
    max-width: 100%;
    font-size: 1.6rem;
    max-width: 600px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }

  b {
    font-family: "PlusJakartaSansBold";
  }

  .dmh-start-title {
    text-align: center;
    font-size: 2.2rem;
    letter-spacing: 0;
    font-family: "DMSans Bold";
    padding: 0;
    color: #192550;
    margin-bottom: 40px;
  }

  .text {
    color: #1e1e22;
    font-size: 1.6rem;
    letter-spacing: 0;
    font-family: "DMSans";
    margin-bottom: 40px;
  }

  .button-group {
    border: 1px solid #0079c8;
    border-radius: 5px;
    background-color: white;
  }

  .date-selector-container {
    min-width: 100%;
    border-radius: 12px;
    padding: 20px;
    width: 500px;
    margin-bottom: 10px;
  }

  .dmh-timeslots-container {
    margin-top: 25px;
    max-width: 500px;
  }

  .date-select-button {
    background-color: white;
    cursor: pointer;
    padding: 10px;
    font-size: 1.8rem !important;
    border: 1px solid white;
    color: #0079c8;
    border-radius: 8px;

    &:hover {
      background-color: #eee;
      border: 1px solid #eee;
    }

    .month-class {
      font-size: 1.4rem;
      color: #ccc;
    }
  }

  .preview-image {
    height: 80px;
    border-radius: 1000px;
    border: 3px solid;
    border-color: inherit;
  }

  .date-select-button:disabled,
  .date-select-button[disabled] {
    cursor: not-allowed;
    background-color: white;
    padding: 10px;
    font-size: 1.8rem !important;
    border: 1px solid white;
    border-radius: 8px;
    color: #ccc;

    &:hover {
      border: 1px solid white;
    }
  }

  .timeslot-button {
    color: #21272a;
    border: 1px solid #0079c8;
  }

  .selected-date {
    background-color: #0079c8;
    color: white;

    &:hover {
      background-color: #0079c8;
      color: white !important;
    }
  }

  .no-appointments {
    font-size: 1.6rem;
  }

  .no-appointments-text {
    padding-top: 25px;
    font-size: 1.6rem;
  }

  .btn-home {
    width: 100%;
    color: #fff;
    letter-spacing: normal;
    border: 0;
    background-color: #604bff;
    border-radius: 12px;
    margin: 0 auto;
  }
}
</style>
